<template>
  <q-card
    flat
    bordered
    class="bg-grey-1 column items-center justify-center"
    style="height: 100%"
  >
    <q-card-section class="title-phone column items-center justify-center full-width">
      <q-btn
        no-caps
        color="primary"
        outline
        style="border-radius: 5px"
        :label="canProceed? 'Próximo contato' : 'Ignorar contato'"
        padding="8px"
        icon-right="mdi-chevron-right"
        class="preview-btn-actions"
        @click="handleAction"
        :disabled="isPaused || isNotConnected || isActuallyDialing "
      />
    </q-card-section>
  </q-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: { },

  props: {
    previewContact: {},
    isDialing: {}
  },

  data () {
    return {

    }
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      isNotConnected: ({ sipModule }) => !sipModule.sipConnected,
      previewQueues: ({ attendanceModule }) => {
        return attendanceModule.preview.contact
      }
    }),

    ...mapGetters({
      sipSessions: 'sipModule/sessionList'
    }),

    hasActiveSipSession () {
      const sessions = this.sipSessions || {}
      return Object.keys(sessions).length > 0
    },

    isActuallyDialing () {
      return this.isDialing && this.hasActiveSipSession
    },

    phones () {
      return this.contacts.phones.map((phone) => ({ number: phone.wa_id ?? phone.phone }))
    },
    queueId () {
      return this.$route.params.queueId
    },

    hasPerfilated () {
      return Boolean(this.previewQueues[this.queueId]?.hasPerfilated)
    },

    hasNewPhone () {
      return Object.values(this.previewQueues[this.queueId]?.phones).some(phone => phone.status === 'NEW')
    },

    hasProfiler  () {
      return this.previewContact.hasProfiler
    },

    canProceed () {
      if (this.isActuallyDialing) return false
      return Boolean(this.hasPerfilated || !this.hasNewPhone || this.hasProfiler)
    }

  },

  methods: {
    ...mapActions({
      call: 'sipModule/call'
    }),

    statusColor (item) {
      if (item.status === 'COMPLETED') return '#12B361'
      if (item.status === 'DISCARDED') return '#FF0000'
      return '#165A9F'
    },

    badgeText (item) {
      if (item.status === 'COMPLETED') return 'Completado'
      if (item.status === 'DISCARDED') return 'Descartado'
      return 'Discar'
    },

    handleAction () {
      if (this.canProceed) return this.$emit('finish-contact')
      this.$emit('skip-contact')
    }

  }

}

</script>
<style lang="sass" scoped>

.preview-btn-actions
  min-width: 200px
  height: 40px
</style>
